export default "__VITE_ASSET__DJMcFqj8__"